import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Index from "./components/dashboard/Index";

import User from "./components/dashboard/User";
import UserCreate from "./components/parts/user/ItemCreate";
import UserUpdate from "./components/parts/user/ItemUpdate";

import Company from "./components/dashboard/Company";
import CompanyCreate from "./components/parts/company/ItemCreate";
import CompanyUpdate from "./components/parts/company/ItemUpdate";

import Scenario from "./components/dashboard/Scenario";
import ScenarioCreate from "./components/parts/scenario/ItemCreate";
import ScenarioUpdate from "./components/parts/scenario/ItemUpdate";

import Character from "./components/dashboard/Character";
import CharacterCreate from "./components/parts/character/ItemCreate";
import CharacterUpdate from "./components/parts/character/ItemUpdate";

import ChoiceValue from "./components/dashboard/ChoiceValue";
import ChoiceValueCreate from "./components/parts/choiceValue/ItemCreate";
import ChoiceValueUpdate from "./components/parts/choiceValue/ItemUpdate";

import Values from "./components/dashboard/Values.vue";
import ValueCreate from "./components/parts/values/ItemCreate.vue";
import ValueUpdate from "./components/parts/values/ItemUpdate";

import Scene from "./components/dashboard/Scene";
import SceneCreate from "./components/parts/scene/ItemCreate";
import SceneUpdate from "./components/parts/scene/ItemUpdate";

import VueMeta from "vue-meta";
import guest from "./middleware/guest";
import auth from "./middleware/auth";
import kibritAdmin from "./middleware/kibritAdmin";
import store from "./store/user";
import middlewarePipeline from "./middlewarePipeline";
import ForgotPassword from "./components/ForgotPassword.vue";

import Report from "./components/dashboard/Report";

Vue.use(VueMeta);
Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/login",
      component: Login,
      name: "login",
      meta: {
        title: "Giriş Paneli",
        middleware: [guest],
      },
    },
    {
      path: "/resetPassword",
      component: ForgotPassword,
      name: "forgotPassword",
      props: true,
      meta: {
        title: "Parolun dəyişdirilməsi",
        middleware: [guest],
      },
    },
    {
      path: "/",
      component: Dashboard,
      children: [
        {
          path: "/",
          component: Index,
          name: "dashboard",
          meta: {
            title: "Pasha Game CMS",
            middleware: [auth],
          },
        },
        //--------------------------- User -----------------------
        {
          path: "/users",
          component: User,
          name: "users",
          meta: {
            title: "Users",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addUser",
          component: UserCreate,
          name: "addUser",
          meta: {
            title: "Add user",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateUser",
          component: UserUpdate,
          name: "updateUser",
          meta: {
            title: "Update user",
            middleware: [auth, kibritAdmin],
          },
        },

        // -------------------------- Company ------------------------
        {
          path: "/companies",
          component: Company,
          name: "Companies",
          meta: {
            title: "Companies",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addCompany",
          component: CompanyCreate,
          name: "addCompany",
          meta: {
            title: "Add Company",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateCompany",
          component: CompanyUpdate,
          name: "updateCompany",
          meta: {
            title: "Update Company",
            middleware: [auth, kibritAdmin],
          },
        },

        // -------------------------- Scenario ------------------------
        {
          path: "/scenarios",
          component: Scenario,
          name: "Scenarios",
          meta: {
            title: "Scenarios",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addScenario",
          component: ScenarioCreate,
          name: "addScenario",
          meta: {
            title: "Add Scenario",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateScenario",
          component: ScenarioUpdate,
          name: "updateScenario",
          meta: {
            title: "Update Scenario",
            middleware: [auth, kibritAdmin],
          },
        },

        // -------------------------- Character ------------------------
        {
          path: "/characters",
          component: Character,
          name: "Characters",
          meta: {
            title: "Characters",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addCharacter",
          component: CharacterCreate,
          name: "addCharacter",
          meta: {
            title: "Add Character",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateCharacter",
          component: CharacterUpdate,
          name: "updateCharacter",
          meta: {
            title: "Update Character",
            middleware: [auth, kibritAdmin],
          },
        },

        // -------------------------- ChoiceValue ------------------------
        {
          path: "/choiceValues",
          component: ChoiceValue,
          name: "ChoiceValues",
          meta: {
            title: "ChoiceValues",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addChoiceValue",
          component: ChoiceValueCreate,
          name: "addChoiceValue",
          meta: {
            title: "Add ChoiceValue",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateChoiceValue",
          component: ChoiceValueUpdate,
          name: "updateChoiceValue",
          meta: {
            title: "Update ChoiceValue",
            middleware: [auth, kibritAdmin],
          },
        },
        // -------------------------- ChoiceValue ------------------------
        {
          path: "/values",
          component: Values,
          name: "Values",
          meta: {
            title: "Values",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addValue",
          component: ValueCreate,
          name: "addValue",
          meta: {
            title: "Add Value",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateValue",
          component: ValueUpdate,
          name: "updateValue",
          meta: {
            title: "Update Value",
            middleware: [auth, kibritAdmin],
          },
        },
        // -------------------------- Scene ------------------------
        {
          path: "/scenes",
          component: Scene,
          name: "Scenes",
          meta: {
            title: "Scenes",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/addScene",
          component: SceneCreate,
          name: "addScene",
          meta: {
            title: "Add Scene",
            middleware: [auth, kibritAdmin],
          },
        },
        {
          path: "/updateScene/:id",

          component: SceneUpdate,
          name: "updateScene",
          meta: {
            title: "Update Scene",
            middleware: [auth, kibritAdmin],
          },
        },

        {
          path: "/Report",
          component: Report,
          name: "Report",
          meta: {
            title: "Statistika",
            middleware: [auth],
          },
        },
      ],
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  mode: "history",
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store,
  };
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});
